import { useCallback } from 'react'
import FormRadio from '../../atoms/FormRadio/FormRadio'

const CheckoutOption = ({
  title = '',
  description = '',
  tag = null,
  checked = false,
  onClick = () => { },
  actions = null,
  fullClick = false,
  moreContent = null,
  className = '',
  name,
  disabled = false,
}) => {

  const handleSelect = useCallback(() => {
    if (disabled || !onClick) return
    onClick()
  }, [onClick, disabled])


  const renderlabelContent = useCallback(() => (
    <div className="checkout-option__label-content">
      {!!title && !!tag ? (
        <div className="checkout-option__title-box">
          <p className="checkout-option__title">{title}</p>
          {tag}
        </div>
      ) : (
        !!title && <p className="checkout-option__title">{title}</p>
      )}
      {!!description && <p className="checkout-option__description">{description}</p>}
    </div>
  ), [title, tag, description])


  const renderBody = useCallback(() => {

    const actionElement = !!actions && <div className="checkout-option__actions">{actions}</div>

    return <div className="checkout-option__body">
      <FormRadio
        className="checkout-option__radio"
        label={renderlabelContent()}
        checked={checked}
        onClick={handleSelect}
        name={name}
        disabled={disabled}
      />
      {actionElement}
    </div>
  }, [renderlabelContent, actions, checked, handleSelect, name, disabled])

  const containerClass = `checkout-option${checked ? ' checkout-option--checked' : ''
    }${className ? ` ${className}` : ''}${disabled ? ' checkout-option--disabled' : ''}`

  const handleContainerClick = useCallback((event) => {
    if (!fullClick || disabled) return
    if (event.target?.closest && event.target.closest('.formradio')) return
    handleSelect()
  }, [handleSelect, fullClick, disabled])

  return (
    <div className={containerClass} onClick={handleContainerClick} role="presentation">
      {renderBody()}
      {moreContent && <div className="checkout-option__more-content">{moreContent}</div>}
    </div>
  )
}

export default CheckoutOption
